import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { Environment } from '@brightside-web/micro/core/environment';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageSelectorService } from '@brightside-web/desktop/feature/language-selection';
import { SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';
import { ServiceInventoryService } from 'libs/desktop/data-access/service-inventory/src/lib/store/service-inventory.service';
import { WelcomeVideoCardService } from '../welcome-video-card.service';

@Component({
    selector: 'brightside-web-welcome-video-card',
    templateUrl: './welcome-video-card.component.html',
    styleUrls: ['./welcome-video-card.component.scss'],
    imports: [BrightsideUiModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))])]),
    ]
})
export class WelcomeVideoCardComponent implements OnInit {
  @ViewChild('videoModalContent') _videoModalContent: TemplateRef<unknown>;

  welcomeVideoActionCard: ActionCardConfigInterface;
  languageSelectorService: LanguageSelectorService = inject(LanguageSelectorService);
  cdnBase: string;

  private _translateService: TranslateService = inject(TranslateService);
  private _env: Environment = inject(Environment);
  private _serviceInventory: ServiceInventoryService = inject(ServiceInventoryService);
  private _welcomeVideoCardService: WelcomeVideoCardService = inject(WelcomeVideoCardService);
  private _globalModalService: SimpleGlobalModalService = inject(SimpleGlobalModalService);

  ngOnInit(): void {
    this.welcomeVideoActionCard = {
      title: this._translateService.instant('VIDEO_WELCOME_TITLE'),
      image: '../assets/welcome-video-banner.png',
      body: this._translateService.instant('VIDEO_WELCOME_DESC'),
      cardStyle: 'large',
      ctaString: this._translateService.instant('VIDEO_WELCOME_CTA'),
      marginBottom: 'small',
    };

    this.cdnBase = this._env.cdnUrl;
  }

  openVideoModal(): void {
    if (!this._videoModalContent) return;
    this._globalModalService.createModal({
      title: this._translateService.instant('WELCOME_VIDEO_TITLE'),
      size: 'large',
      displayCloseButton: true,
      eventName: 'welcome_video_modal',
      isError: false,
      templateRef: this._videoModalContent,
      closeAction: () => this._closeVideoModal(),
    });
  }

  private _closeVideoModal(): void {
    this._welcomeVideoCardService.removeWelcomeVideoInitialCard();
    this._serviceInventory.deleteServiceState('video_welcome');
    this._globalModalService.clearModal();
  }
}
